var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#506D85",
    fillRule: "nonzero",
    stroke: "#506D85",
    strokeWidth: 0.504
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.884 14.135a.402.402 0 0 0-.401.403v3.58c-.001.668-.54 1.21-1.204 1.21H6.022a1.208 1.208 0 0 1-1.204-1.21V7.611c.001-.667.54-1.208 1.204-1.21h3.562a.402.402 0 1 0 0-.806H6.022a2.013 2.013 0 0 0-2.006 2.016V18.12a2.013 2.013 0 0 0 2.006 2.016h11.257a2.013 2.013 0 0 0 2.006-2.016v-3.58a.402.402 0 0 0-.401-.404z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.126 4.558a1.799 1.799 0 0 0-2.553 0l-7.158 7.193a.404.404 0 0 0-.103.178l-.94 3.415a.4.4 0 1 0 .494.496l3.397-.946a.4.4 0 0 0 .177-.103l7.157-7.194a1.823 1.823 0 0 0 0-2.566l-.47-.473zm-8.836 7.455l5.857-5.887 1.89 1.899-5.858 5.887-1.89-1.899zm-.378.761l1.51 1.517-2.088.582.578-2.099zm9.118-5.747l-.426.428-1.89-1.9.426-.427a1 1 0 0 1 1.419 0l.47.473a1.013 1.013 0 0 1 0 1.426z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit2);
export default __webpack_public_path__ + "static/media/edit2.1ee919ea5c0555b1f3c8df59c18e6301.svg";
export { ForwardRef as ReactComponent };